import { createVNode, render } from 'vue';
import InfoModal from '../InfoModal.vue';
import { i18n } from '@/i18n';

let sessionModalOpen = false; // ← いま出してるかのセマフォ

/**
 * セッションエラー情報を表示するモーダルを表示
 */
export async function displaySessionErrorInfo(): Promise<void> {
  // すでに表示中なら何もしない（多重起動防止）
  if (sessionModalOpen) return;

  //login 上では出さない（遷移後の再発火対策）
  if (location.pathname === '/login' || location.pathname === '/#/login') return;

  sessionModalOpen = true;

  const container = document.createElement('div');
  document.body.appendChild(container);

  const t = i18n.t;

  /**
   * モーダルを閉じるための関数
   */
  const close = () => {
    render(null, container);
    container.remove();
    sessionModalOpen = false;
  };

  const vNode = createVNode(
    InfoModal,
    {
      modalState: true,
      nextButtonLabel: t('OK'), // ← i18n に寄せるならこっち
      icon: 'error',
      enableOutsideClick: false,

      // InfoModal が 'on-next' を emit する前提。VNode 側では onOnNext になる
      // eslint-disable-next-line jsdoc/require-jsdoc
      onOnNext: async () => {
        close();
        location.href = '/#/login';
      },
    },
    {
      // eslint-disable-next-line jsdoc/require-jsdoc
      title: () => t('セッションが期限切れです'),
      // eslint-disable-next-line jsdoc/require-jsdoc
      description: () => t('再度ログインしてください。'),
    }
  );

  render(vNode, container);
}
